import axios from "axios";
import { DEFAULT_TRACK_ROUTE, GENERIC_TRACK_ERROR } from "./constants";
import isClientSide from "./isClientSide";
const sendClientSideSplitTrackEvent = async (trackArguments, splitKey, { apiPathString = DEFAULT_TRACK_ROUTE, } = {}) => {
    try {
        if (!isClientSide()) {
            throw new Error("Cannot use sendClientSideSplitTrackEvent server-side. Use sendServerSideSplitTrackEvent instead.");
        }
        await axios.post(apiPathString, {
            trackArguments: typeof trackArguments === "object"
                ? JSON.stringify(trackArguments)
                : trackArguments,
        }, { params: { splitKey: await splitKey } });
        return true;
    }
    catch (e) {
        console.error(new Error(axios.isAxiosError(e)
            ? e.response
                ?.data.error || GENERIC_TRACK_ERROR
            : (typeof e === "object" && e.message) || GENERIC_TRACK_ERROR));
        return false;
    }
};
export default sendClientSideSplitTrackEvent;
